import React from "react";
import { Link } from "react-router-dom";

// Default cards. Admin (Home Sections) can change them; saved in siteConfig/homepage.seriesCards.
// seriesNames = the "Series" values set on the books (English and Spanish) that belong to this series.
export const DEFAULT_SERIES_CARDS = [
    { slug: "kingsman", title: "The Kingsman Series", description: "", imageUrl: "", seriesNames: ["Kingsman", "El Sr Kingsman"] },
    { slug: "under-the-sky", title: "The Under the Sky Series", description: "", imageUrl: "", seriesNames: ["Under the Sky", "Bajo La Luna"] },
    { slug: "dfury", title: "The Dfury Series", description: "", imageUrl: "", seriesNames: ["Dfury"] },
];

export default function SeriesCards({ cards }) {
    const list = cards && cards.length > 0 ? cards : DEFAULT_SERIES_CARDS;

    return (
        <section style={{ padding: "80px 20px", background: "#f7f5f0" }}>
            <div style={{ maxWidth: 1100, margin: "0 auto" }}>
                <h2 style={{ fontFamily: "'Playfair Display', serif", textAlign: "center", fontSize: "2.2rem", color: "var(--primary)", margin: "0 0 48px" }}>
                    The Series
                </h2>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 28 }}>
                    {list.map(card => (
                        <Link
                            key={card.slug}
                            to={"/series/" + card.slug}
                            style={{ textDecoration: "none", color: "inherit", display: "block", borderRadius: 16, overflow: "hidden", background: "#fff", boxShadow: "0 6px 20px rgba(0,0,0,0.08)" }}
                        >
                            <div style={{ height: 260, padding: card.imageUrl ? 12 : 0, boxSizing: "border-box", background: card.imageUrl ? (card.background || "#1a1a2e") : "linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%)" }}>
                                {card.imageUrl && (
                                    <img src={card.imageUrl} alt={card.title} style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} />
                                )}
                            </div>
                            <div style={{ padding: 22 }}>
                                <h3 style={{ fontFamily: "'Playfair Display', serif", margin: "0 0 8px", color: "var(--primary)" }}>{card.title}</h3>
                                <span style={{ color: "var(--accent)", fontWeight: 700, fontSize: 14 }}>Explore the series →</span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
